import CourseDocumentIcon from '@/assets/ui/activity/course-document.svg';
import CourseQuizIcon from '@/assets/ui/activity/course-quiz.svg';
import CourseResourceIcon from '@/assets/ui/activity/course-resource.svg';
import CourseVideoIcon from '@/assets/ui/activity/course-video.svg';
import PlayIcon from '@/assets/ui/activity/play.svg';
import CheckCircleIcon from '@/assets/ui/activity/check-circle.svg';
import ClockIcon from '@/assets/ui/activity/clock.svg';
import BookOpenIcon from '@/assets/ui/activity/book-open.svg';
import CheckSquareIcon from '@/assets/ui/activity/check-square.svg';

export {
  CourseDocumentIcon,
  CourseQuizIcon,
  CourseResourceIcon,
  CourseVideoIcon,
  PlayIcon,
  CheckCircleIcon,
  ClockIcon,
  BookOpenIcon,
  CheckSquareIcon,
};
